module.exports = __webpack_public_path__ + "img/pencil.b0753817.svg";